module.exports = "<template>\n  <div class=\"odsSmallIndicator -fullHeight\"></div>\n</template>\n";